export enum ReportsFilterType {
    OverviewReport = 1,
    AuthReport = 2,
    TpnNegotiationReport = 3,
    TpnReconsiderationReport = 4,
    PaymentReport = 5,
    ArReports = 6,
    ClaimStatusReport = 7,
    ChargesBilledReport = 8,
    ProjectedCensusReport = 9,
}

export enum ClaimStatusReportType {
    None = 0,
    Pending = 1,
    InProgress = 2,
    MREscalation = 3
}


export enum CereusReportType {
    EnterpriseOverviewReport = 1,
    ChargesBilledSummaryReport = 2,
    ChargesBilledDetailReport = 3,
    ChargesBilledYearlyTrendReport = 4,
    PaymentsSummaryReport = 5,
    PaymentsDetailReport = 6,
    PaymentsYearlyTrendReport = 7,
    ArPayerBreakdownReport = 8,
    ArOpenChargesReport = 9,
    ArPatientBalanceReport = 10,
    ArWaterFallReport = 11,
    UrReport = 12,
    TpnNegotiationReport = 13,
    TpnReconsiderationReport = 14,
    ClaimStatusOverviewReport = 15,    
    ClaimStatusPendingReport = 16,
    ClaimStatusInProgressReport = 17,
    ClaimStatusMrEscalationReport = 18,
    EivPolicyLookupReport = 19,
    EivProjectedCensusReport = 20,
    EivAllChargesProjectedReport = 21,
    EivMonthlyProjectionReport = 22,
}